import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Card,
  CardContent,
  LinearProgress,
  TablePagination,
} from "@mui/material";
import { api_Routes } from "../../../api_Routes";
import { Helper } from "../../../tools/Helper";
import { useNavigate } from "react-router-dom";

const SkypeGroup = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [history, setHistory] = useState([]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };
  const navigate = useNavigate();

  const getTelegramGroups = async () => {
    setIsLoading(true);
    const url = `${api_Routes.SocialGroup.Skype}?per_page=${rowsPerPage}&page=${currentPage + 1}`;
    const { response } = await Helper.Get({
      url: url,
      hasToken: true,
    });
    if (response) {
      setData(response);
      setHasAccess(response?.pagination?.hasAccess)
      setHistory(
          response.data.map((history) => ({
            title: history.title,
            owner: history.owner,
            url: history.url,

          }))
      );
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getTelegramGroups();
  }, [ currentPage, rowsPerPage]);
  return (
    <Box>
      <Typography
        sx={{
          color: "#474747",
          fontWeight: "600",
          fontSize: "24px",
          lineHeight: "30px",
        }}
      >
        Skype Groups
      </Typography>
      <Card>
        <CardContent sx={{ background: "#F8FAFF" }}>
          {isLoading && <LinearProgress />}
          {data?.length === 0 ? (
            <Typography sx={{ textAlign: "center" }}>
              There are no Groups yet
            </Typography>
          ) : (
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "none",
                borderBottom: "1px solid #00000080",
                marginTop: "20px",
              }}
            >
              <Table>
                <TableHead sx={{ borderBottom: "1px solid #00000080" }}>
                  <TableRow sx={{ backgroundColor: "#D1DDE4" }}>
                    <TableCell
                      align="left"
                      sx={{ fontWeight: "bold", color: "#333333" }}
                    >
                      Title
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ fontWeight: "bold", color: "#333333" }}
                    >
                      Owner
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: "bold", color: "#333333" }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {history.map((group) => (
                    <TableRow
                      key={group.id}
                      hover
                      sx={{
                        backgroundColor: "#E5EDFF",
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#D0DDFF !important" },
                      }}
                      onClick={() => window.open(group.url, "_blank")}
                    >
                      <TableCell align="left">{group.title}</TableCell>
                      <TableCell align="left">{group.owner}</TableCell>
                      <TableCell
                          align="center"
                        sx={{
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="error"
                          sx={{
                            ml: 1,
                            backgroundColor: "green",
                            color: "#fff",
                            boxShadow:
                              "0px 3px 3px #00000040, inset 0px 4px 7px #FFFFFF40",
                            borderRadius: "10px",
                            "&:hover": {
                              backgroundColor: "#2d5aa3",
                            },
                          }}
                          onClick={() => window.open(group.url, "_blank")}
                        >
                          Open It
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <div className="mt-4 flex justify-center items-center">
                {
                  hasAccess ?
                      <TablePagination
                          page={currentPage}
                          className="mt-auto"
                          onPageChange={handlePageChange}
                          count={data?.pagination?.total}
                          rowsPerPage={rowsPerPage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          variant="outlined"
                          shape="rounded"
                          rowsPerPageOptions={[5, 10, 25, 50]}
                      />:
                      <Typography sx={{ textAlign: "center" }}>
                        You Must subscrip membership Which contain access to Skype groups to show more
                      </Typography>
                }

              </div>
            </TableContainer>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default SkypeGroup;
